import React from 'react';
import PropTypes from 'prop-types';
import ReactAutosuggest from 'react-autosuggest';
import { get } from 'lodash';
import Panel from '../Panel';
import Spin from '../Spin';
import Input from '../Input';
import styles from './styles.module.scss';

export default class Autosuggest extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool,
  };

  static defaultProps = {
    isLoading: false,
  };

  renderSuggestionsContainer = ({ containerProps, children }) => {
    return (
      <Panel shadowSize="sm" style={{ width: get(this.input, 'offsetWidth') }} {...containerProps}>
        {children}
      </Panel>
    );
  };

  renderInputComponent = inputProps => {
    const { isLoading } = this.props;

    return (
      <div
        ref={c => {
          this.input = c;
        }}
        className={styles['input-container']}
      >
        <Input {...inputProps} />
        {isLoading && (
          <div className={styles['spin-container']}>
            <Spin />
          </div>
        )}
      </div>
    );
  };

  render() {
    return (
      <ReactAutosuggest
        theme={styles}
        renderSuggestionsContainer={this.renderSuggestionsContainer}
        renderInputComponent={this.renderInputComponent}
        focusInputOnSuggestionClick={false}
        {...this.props}
      />
    );
  }
}
